import PropTypes from 'prop-types';
import React from 'react';

import Station from '../../records/Station';
import MapsHelper from '../../helpers/GoogleMaps';
import config from '../../config';

export default class StationMarker extends React.PureComponent {
    static propTypes = {
        station: PropTypes.instanceOf(Station),
        mapsHelper: PropTypes.instanceOf(MapsHelper),
        onSelect: PropTypes.func.isRequired
    }

    marker = null;

    addMarker () {
        const { station } = this.props;

        const icon = {
            url: `/images/add-station-${config.get('brand').split('-')[0]}.png`,
            fillOpacity: 1,
            scaledSize: new window.google.maps.Size(64, 80),
            anchor: new window.google.maps.Point(26.5, 78)
        };

        this.addMarkerAsync(() => {
            this.marker.addListener('click', () => { this.props.onSelect(station); });
        }, icon, station);
    }

    addMarkerAsync(callback, icon, station) {
        setTimeout(() => {
            this.marker = this.props.mapsHelper.addMarker({
                position: station.getLatLng(),
                icon: icon,
                title: station.name,
                animation: 'DROP',
                optimized: false,
            });
            callback();
        }, (Math.random() * 0.99) * 1000);
    }

    removeMarker () {
        if (this.marker) {
            this.marker.setMap(null);
            this.marker = null;
        }
    }

    componentDidMount () {
        this.addMarker();
    }

    componentWillUnmount () {
        this.removeMarker();
    }

    render () {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/stationFinder/StationMarker.js